import { render, staticRenderFns } from "./NotAllow.vue?vue&type=template&id=4a41d7a9&scoped=true&"
import script from "./NotAllow.vue?vue&type=script&lang=js&"
export * from "./NotAllow.vue?vue&type=script&lang=js&"
import style0 from "./NotAllow.vue?vue&type=style&index=0&id=4a41d7a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a41d7a9",
  null
  
)

export default component.exports